import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "../../../core/winpresentation/SimplePresentationRunner";
import {TheBorder} from "../../TheBorder";
import {gsap} from "gsap";
import {TheBorderXNudgeSymbol} from "../../reels/TheBorderXNudgeSymbol";
import {TheBorderStatics} from "../../TheBorderStatics";
import {TheBorderSound} from "../../sound/TheBorderSound";

/**
 * Created by Jerker Nord on 2022-05-02.
 */

export class TheBorderXNudgeWinRunner implements SimplePresentation {

    private _mainTL:gsap.core.Timeline;
    private _xNudgeWinReels:boolean[];

    constructor() {

    }

    private static parseXNudgeWinReels(reels:string[][], evaluatedArea:string[][]):boolean[] {
        //Checking every reel for xNudge (there can only be one on every reel)
        const xNudgeWinReels:boolean[] = [false, false, false, false, false, false];
        for(let i:number = 0; i < reels.length; i++) {
            for(let j:number = 0; j < reels[i].length; j++) {
                if(reels[i][j] === "WR" || reels[i][j] === "WR_H") {
                    if(j > 0 && (evaluatedArea[i][j - 1] === "WR" || evaluatedArea[i][j - 1] === "WR_H")) {
                        xNudgeWinReels[i] = true;
                    }
                    if(j < (reels[i].length - 1) && (evaluatedArea[i][j + 1] === "WR" || evaluatedArea[i][j + 1] === "WR_H")) {
                        xNudgeWinReels[i] = true;
                    }
                }
            }
        }
        return xNudgeWinReels;
    }

    public shouldRun():boolean {
        this._xNudgeWinReels = TheBorderXNudgeWinRunner.parseXNudgeWinReels(TheBorder.allReelsView.getAllReelsSymbolName(), TheBorder.model.evaluatedArea);
        return this._xNudgeWinReels.includes(true);
    }

    public start(controller:SimplePresentationRunnerController):void {
        this._mainTL = gsap.timeline();
        this._mainTL.add(() => controller.setSkipCallback(() => this.skip()));

        //Play win animation on all WR
        for(let i:number = 0; i < this._xNudgeWinReels.length; i++) {
            if(this._xNudgeWinReels[i]) {
                let xNudgeSymbolOnReel:TheBorderXNudgeSymbol = TheBorder.xNudgeSymbols.getXNudgeSymbolOnReel(i);
                this._mainTL.add([
                    xNudgeSymbolOnReel.getWinAnimation().restart(),
                    () => {
                        TheBorder.soundPlayer.playSound(TheBorderSound.NUDGE_SOUND);//#245
                        if(xNudgeSymbolOnReel.splitLevel > 1) {
                            TheBorder.swooshAnimation.playSwoosh(xNudgeSymbolOnReel.position.x + (TheBorderStatics.reelPositions[i].x), xNudgeSymbolOnReel.position.y, 610, -84).eventCallback("onComplete", () => {
                                TheBorder.winMultiplierView.addToWinMultiplier(xNudgeSymbolOnReel.splitLevel);
                            });
                        }
                    }
                ]);
                this._mainTL.add(() => {
                    TheBorder.xNudgeView.getAllSymbolTransformAnimations(i, xNudgeSymbolOnReel.reelPosition, controller.finish);
                });
            }
        }

        if(this._mainTL.duration() == 0) {
            this._mainTL.to(this, {duration : 0.001});
        }
    }

    private skip():void {
        this._mainTL.totalProgress(1);
        TheBorder.xNudgeView.abort();
    }
}